<template>
    <FormItem :label="title">
        <div class="demo-upload-list" v-if="uploadList.length > 0 || !!currentValue">
            <template v-if="!!currentValue || uploadList[0].status === 'finished'">
                <img :src="currentValue|prepandImg">
                <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(currentValue)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove()"></Icon>
                </div>
            </template>
            <template v-else>
                <Progress v-if="uploadList[0].showProgress" :percent="uploadList[0].percentage" hide-info></Progress>
            </template>
        </div>

        <Upload v-show="uploadList.length == 0 && !currentValue"
                ref="upload"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="maxSize"
                :on-exceeded-size="handleMaxSize"
                :show-upload-list="false"
                :before-upload="handleBeforeUpload"
                type="drag"
                :headers="{'x-token':$store.getters.token }"
                :action="action"
                style="display: inline-block;width:60px;">
            <div style="width: 60px;height:60px;line-height: 60px;">
                <!--<img v-show="!!currentValue" :src="currentValue|prepandImg"
                     style="width: 60px;height: 60px;"/>-->
                <Icon v-show="!currentValue" type="ios-camera" size="20"></Icon>
            </div>
        </Upload>
        <!--<p v-show="!!currentValue" @click="currentValue=''" style="width: 60px;text-align: center;cursor: pointer;margin-top: -10px;">清除</p>
        <p v-if="tips" class="p-tips">{{tips}}</p>-->

        <Modal title="图片预览" v-model="visible" width="900">
            <img :src="imgUrl|prepandImg" v-show="visible" style="width: 100%">
        </Modal>
    </FormItem>
</template>

<script>
    import mixins from './mixins'
    import compress from "../../libs/compress";

    export default {
        name: "do-picture",
        mixins: [mixins],
        components: {
        },
        props: {
            maxSize: {
                type: Number,
                default: 2048
            },
            reportWatermark: {
                type: Boolean,
                default: false
            },
            reportId:{
                type:Number,
                default:0
            },
            timeStamp:{
                type:String,
                default:''
            }
        },
        data() {
            return {
                imgUrl:'',
                visible:false,
                status:'undo',
                uploadList:[]
            }
        },
        computed: {
            action:function() {
                if(this.reportWatermark){
                    return '/supervise/admin/upload/uploadReportImage?reportId='+this.reportId+"&timeStamp="+this.timeStamp;
                }
                return '/supervise/admin/upload/uploadFile';
            }
        },
        methods: {
            handleSuccess(res) {
                if (res.success){
                    this.currentValue = '/'+res.data.path;
                } else if (res.message == '-5') {
                    this.$store.dispatch('Logout').then(() => {
                        //this.LoadingBar.finish();
                        this.$router.push('/login');
                    });
                } else {
                    this.$Message.error(res.message||'未知错误')
                }
                //this.$emit('change', this.currentValue)
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: '尺寸错误',
                    desc: '图片  ' + file.name + ' 尺寸太大, 图片必须小于 2M.'
                });
            },
            handleBeforeUpload(file) {
                let maxSize = this.maxSize
                if (file.size <= maxSize * 1024) {
                    console.log('不需要压缩');
                    return true;
                } else {
                    return new Promise(async (resolve, reject) => {
                        compress(file, maxSize).then(res=>{
                            resolve(res.compressFile)
                        })
                    })
                }
                // console.log(this.$refs.upload.fileList)
            },
            handleView(url) {
                this.imgUrl = url;
                this.visible = true;
            },
            handleRemove() {
                this.$refs.upload.fileList.length > 0 && this.$refs.upload.fileList.splice(0, 1);
                this.currentValue=''
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.uploadList = this.$refs.upload.fileList;
            });
        },
        filters:{
            prepandImg(url){
                if(url){
                    return '/supervise'+url
                }
                return null
            }
        },
        watch:{
            value(val) {
                !val && (this.uploadList=[])
            }
        }
    }
</script>
<style scoped>
    .demo-upload-list {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>
